(() => {
  const toggleSelector = 'details[data-description-toggle="animated"]';
  const contentSelector = '[data-description-toggle-content]';

  const parseTimeToMs = (timeValue) => {
    const value = (timeValue || '').trim();

    if (!value) return 0;
    if (value.endsWith('ms')) return Number.parseFloat(value);
    if (value.endsWith('s')) return Number.parseFloat(value) * 1000;

    return Number.parseFloat(value) || 0;
  };

  const getTransitionMs = (element) => {
    const styles = window.getComputedStyle(element);
    const durations = styles.transitionDuration.split(',');
    const delays = styles.transitionDelay.split(',');

    return durations.reduce((max, duration, index) => {
      const delay = delays[index] || delays[0] || '0s';
      const total = parseTimeToMs(duration) + parseTimeToMs(delay);
      return Math.max(max, total);
    }, 0);
  };

  const setSummaryState = (details, expanded) => {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const animateHeight = (element, from, to, onDone) => {
    if (from === to) {
      onDone();
      return;
    }

    element.style.height = `${from}px`;
    element.offsetHeight;
    element.style.height = `${to}px`;

    const transitionMs = getTransitionMs(element);
    if (transitionMs === 0) {
      onDone();
      return;
    }

    let finished = false;
    let fallbackTimer;

    const finish = () => {
      if (finished) return;
      finished = true;
      window.clearTimeout(fallbackTimer);
      element.removeEventListener('transitionend', handleTransitionEnd);
      onDone();
    };

    const handleTransitionEnd = (event) => {
      if (event.target !== element || event.propertyName !== 'height') return;
      finish();
    };

    fallbackTimer = window.setTimeout(finish, transitionMs + 80);
    element.addEventListener('transitionend', handleTransitionEnd);
  };

  const openDetails = (details, content) => {
    details.classList.add('is-animating');
    details.open = true;
    content.style.height = '0px';
    const targetHeight = content.scrollHeight;

    animateHeight(content, 0, targetHeight, () => {
      details.classList.remove('is-animating');
      content.style.height = 'auto';
      setSummaryState(details, true);
    });
  };

  const closeDetails = (details, content) => {
    details.classList.add('is-animating');
    const startHeight = content.scrollHeight;

    animateHeight(content, startHeight, 0, () => {
      details.classList.remove('is-animating');
      details.open = false;
      content.style.height = '0px';
      setSummaryState(details, false);
    });
  };

  const initToggle = (details) => {
    if (details.dataset.descriptionToggleInitialized === 'true') return;

    const summary = details.querySelector('summary');
    const content = details.querySelector(contentSelector);
    if (!summary || !content) return;

    details.dataset.descriptionToggleInitialized = 'true';
    content.style.height = details.open ? 'auto' : '0px';
    setSummaryState(details, details.open);

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.classList.contains('is-animating')) return;

      if (details.open) {
        closeDetails(details, content);
      } else {
        openDetails(details, content);
      }
    });
  };

  const init = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(toggleSelector).forEach(initToggle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
